export function isStrongPassword (password) {
  if (typeof password !== 'string' || password.length < 8 || password.length > 64 || !/^[!-~]+$/.test(password)) {
    return false
  }
  const categories = [/[0-9]/, /[A-Z]/, /[a-z]/, /[^0-9A-Za-z]/]
  return categories.filter(pattern => pattern.test(password)).length >= 3
}
